import { NavLink, useLocation } from "react-router-dom";
import { BOTTOM_TABS } from "../../../constant/menulist";
import { useLoginGate } from "../../../context/login-gate";
import useAuth from "../../../hooks/useAuth";
import "./bottom-tab-bar-style.scss";

//底部導覽
//  定位由 .app-fixed 那層負責對齊 app 欄位（見 index.scss）。
//
//  需要登入的頁籤（提問、我的）未登入時「不導頁」，而是在原地跳登入彈窗 ——
//  這樣彈窗後面還是使用者本來在看的畫面，不會變成一片空白。
//
//  圖示用 key 對應，不放進 constant：constant 只該放資料，放 JSX 會讓它變成
//  不能序列化的東西（之後若要改由 API 提供選單就會卡住）。
const ICONS = {
  //探索：羅盤 —— 呼應命理主題，也比房子更貼近「逛看看」的行為
  explore: (
    <svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true">
      <circle
        cx="12"
        cy="12"
        r="9"
        stroke="currentColor"
        strokeWidth="1.8"
        fill="none"
      />
      <path
        d="M15.4 8.6l-2 4.8-4.8 2 2-4.8z"
        stroke="currentColor"
        strokeWidth="1.8"
        fill="none"
        strokeLinejoin="round"
      />
    </svg>
  ),
  //問卦：對話框加問號 —— 找老師談一件具體的事
  ask: (
    <svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true">
      <path
        d="M20 15a3 3 0 01-3 3H9l-4 3v-3H7a3 3 0 01-3-3V7a3 3 0 013-3h10a3 3 0 013 3z"
        stroke="currentColor"
        strokeWidth="1.8"
        fill="none"
        strokeLinejoin="round"
      />
      <path
        d="M10.3 8.9a1.9 1.9 0 113 1.6c-.5.4-.9.8-.9 1.4"
        stroke="currentColor"
        strokeWidth="1.7"
        fill="none"
        strokeLinecap="round"
      />
      <circle cx="12.4" cy="14.7" r="0.9" fill="currentColor" />
    </svg>
  ),
  //提問：圈起來的問號。
  //  刻意不用對話框 —— 上一格的「問卦」已經是對話框了，
  //  兩個相鄰的頁籤用同一種形狀，掃過去分不出來。
  question: (
    <svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true">
      <circle
        cx="12"
        cy="12"
        r="9"
        stroke="currentColor"
        strokeWidth="1.8"
        fill="none"
      />
      <path
        d="M9.6 9.4a2.5 2.5 0 114 2.1c-.7.5-1.2 1-1.2 1.9"
        stroke="currentColor"
        strokeWidth="1.8"
        fill="none"
        strokeLinecap="round"
      />
      <circle cx="12.4" cy="16.6" r="1" fill="currentColor" />
    </svg>
  ),
  //我的：人像
  mine: (
    <svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true">
      <circle
        cx="12"
        cy="8.5"
        r="3.7"
        stroke="currentColor"
        strokeWidth="1.8"
        fill="none"
      />
      <path
        d="M4.8 20a7.2 7.2 0 0114.4 0"
        stroke="currentColor"
        strokeWidth="1.8"
        fill="none"
        strokeLinecap="round"
      />
    </svg>
  ),
};

const BottomTabBar = () => {
  const { requireLogin } = useLoginGate();
  const { isLoggedIn } = useAuth();
  const { pathname } = useLocation();

  return (
    <nav className="btb" aria-label="主要導覽">
      <div className="btb__inner">
        {BOTTOM_TABS.map((tab) => {
          const gated = tab.needAuth && !isLoggedIn;

          //需要登入但還沒登入 → 用 button，點了跳彈窗而不是導頁
          if (gated) {
            return (
              <button
                key={tab.key}
                type="button"
                className="btb__item"
                onClick={() => requireLogin(tab.path, tab.authMessage)}
              >
                {ICONS[tab.key]}
                <span className="btb__label">{tab.label}</span>
              </button>
            );
          }

          return (
            <NavLink
              key={tab.key}
              to={tab.path}
              //探索指向 "/"，不加 end 的話每一頁都會把它算成 active
              end={tab.path === "/"}
              className={({ isActive }) =>
                //帳號中心底下還有「個人檔案」（/my-page），那一頁也該讓「我的」保持亮著
                isActive || (tab.key === "mine" && pathname === "/my-page")
                  ? "btb__item is-active"
                  : "btb__item"
              }
            >
              {ICONS[tab.key]}
              <span className="btb__label">{tab.label}</span>
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
};

export default BottomTabBar;
